
import { defineComponent } from '@vue/composition-api';
import IllinoisIcons from '../icons.vue';
import InlineAlert from './Errors/InlineAlert.vue';
import { OddsToUpdate } from '../../../../../types/sport';

export default defineComponent({
  name: 'IllinoisActions',
  components: { IllinoisIcons, InlineAlert },
  props: {
    hideBetAmount: {
      type: Boolean,
      default: false
    },
    showWinningAmount: {
      type: Boolean,
      default: false
    },
    hideInlineAlerts: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open-cart-pending'],
  data() {
    return {
      showAlertLogin: false,
      showAlertNotPlayable: false,
      warningOddsChanged: false
    };
  },
  computed: {
    getBet(): any {
      return this.$store.getters['cart/getBet'];
    },
    getAuthenticated(): boolean {
      return this.$store.getters['user/getAuthenticated'];
    },
    getCanPlay(): boolean {
      return this.$store.getters['user/getCanPlay'];
    },
    getLanguage(): string {
      return this.$store.getters['settings/getLanguage'];
    },
    getOddsVariation(): boolean {
      return this.$store.getters['cart/getOddsVariation'];
    },
    getSettings(): any {
      return this.$store.getters['cart/getSettings'];
    },
    getIsCartUpdating(): boolean {
      return this.$store.getters['cart/getIsCartUpdating'];
    },
    hasBetError(): boolean {
      return this.$store.getters['sport/hasBetError'];
    },
    displayBetAmount(): number {
      try {
        const bet = this.getBet || {};
        switch (bet.type) {
          case 'single':
          case 'multiple':
            return +bet._multiple_detail?.amount || 0;
          case 'integral': {
            /* const amount = +bet._integral_detail?.amount || 0;
            const combinations = +bet._integral_detail?.combinations || 0; */
            return this.amountTotalComputed;
          }
          case 'system':
            return +bet._system_detail?.amount_system || 0;
          default:
            return 0;
        }
      } catch (e) {
        return 0;
      }
    },
    displayWinning(): number {
      try {
        const bet = this.getBet || {};
        switch (bet.type) {
          case 'single':
          case 'multiple':
            return +bet._multiple_detail?.winning_total || 0;
          case 'integral':
            return +bet._integral_detail?.winning_total_max || 0;
          case 'system': {
            const sys = bet._system_detail || {};
            if (sys.winning_all_total != null) return +sys.winning_all_total;
            if (sys.winning_all != null) return +sys.winning_all;
            return 0;
          }
          default:
            return 0;
        }
      } catch (e) {
        return 0;
      }
    },
    disablePlace(): boolean {
      return (
        (!this.getBet.check &&
          this.getBet.errors &&
          this.getBet.errors.length > 0) ||
        this.hasOddsToUpdate.length > 0 ||
        this.getIsCartUpdating === true
      );
    },
    disableBook(): boolean {
      return (
        (!this.getBet.check &&
          this.getBet.errors &&
          this.getBet.errors.length > 0) ||
        this.hasOddsToUpdate.length > 0 ||
        this.getBet.context !== 'prematch'
      );
    },
    oddsToUpdate(): any[] {
      return this.$store.getters['IllinoisSport/getOddsToUpdate'] || [];
    },
    hasOddsToUpdate(): boolean {
      return this.oddsToUpdate.length > 0;
    },
    shouldShowConfirmButton(): boolean {
      return this.hasOddsToUpdate;
    },
    shouldDisableConfirmButton(): boolean {
      if (this.shouldShowConfirmButton) {
        return false; // Il bottone di conferma non è mai disabilitato
      }
      return this.disablePlace;
    },
    amountTotalComputed() {
      const amount = +this.getBet._integral_detail.amount || 0;
      const combinations = +this.getBet._integral_detail.combinations || 1;

      return this.getSettings.integralDivided ? amount : amount * combinations;
    },
    /**
     * Verifica se ci sono quote cambiate che l'utente deve accettare
     * Ritorna true se almeno una quota ha il flag "changed" a true
     */
    hasChangedOdds(): boolean {
      const odds = this.getBet && this.getBet.odds ? this.getBet.odds : [];
      console.log('[hasChangedOdds] Odds lette da getBet:', {
        oddsLength: odds.length,
        odds: odds,
        oddsWithChangedProperty: odds.filter((odd: any) => 'changed' in odd),
        oddsWithChangedTrue: odds.filter((odd: any) => odd.changed === true),
        oddsWithChangedFalse: odds.filter((odd: any) => odd.changed === false),
        oddsDetails: odds.map((odd: any) => ({
          unique_id: odd.unique_id,
          hasChanged: 'changed' in odd,
          changedValue: odd.changed,
          keys: Object.keys(odd)
        }))
      });
      const oddsChanged = odds.filter((odd: any) => odd.changed === true);
      console.log('[hasChangedOdds] Risultato filter:', {
        oddsChangedLength: oddsChanged.length,
        oddsChanged: oddsChanged,
        oddsChangedDetails: oddsChanged.map((odd: any) => ({
          unique_id: odd.unique_id,
          changed: odd.changed,
          keys: Object.keys(odd)
        })),
        result: oddsChanged.length > 0
      });
      return oddsChanged.length > 0;
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    },
    /**
     * Formatta un numero per la visualizzazione (es. 1000 -> 1.000)
     */
    formatNumber(amount: number): string {
      try {
        return new Intl.NumberFormat().format(amount || 0);
      } catch (e) {
        return String(amount || 0);
      }
    },

    /**
     * Piazza la scommessa (Place Bet)
     *
     * Flusso:
     * 1. Verifica autenticazione utente
     * 2. Verifica se l'utente può giocare (getCanPlay)
     * 3. Verifica che non ci siano errori nel carrello
     * 4. Invia la richiesta API tramite cart/placeBet
     * 5. In caso di successo: mostra dialog con codice bet
     * 6. In caso di errore: gestisce con handlePlaceBetError
     */
    async saveBet() {
      // Controllo autenticazione: se l'utente non è autenticato, mostra alert e apre login
      console.log(
        'getAuthenticated',
        this.$store.getters['user/getAuthenticated']
      );
      if (this.$store.getters['user/getAuthenticated'] === false) {
        console.log('openLogin');
        window.parent.postMessage(
          {
            type: 'openLogin'
          },
          '*'
        );
        this.showAlertLogin = true;
        return;
      }

      // Controllo se l'utente può giocare (potrebbe essere bloccato o con restrizioni)
      if (this.getCanPlay === false) {
        this.showAlertNotPlayable = true;
        return;
      }

      if (this.getIsCartUpdating === true) return;

      await this.$store.dispatch('cart/setIsCartUpdating', true);

      const response: any = await this.$store.dispatch('cart/placeBet', {
        betContext: this.getBet.context,
        lang: this.getLanguage,
        accept_odds: this.getOddsVariation
      });

      console.log('[saveBet] Response:', response);

      if (response && response.result === true) {
        this.warningOddsChanged = false;
        await this.$store.dispatch('IllinoisSport/setBetOutcomeSuccess', {
          bet_code: response.bet_code || '',
          short_code: response.shortCode || ''
        });
        await this.$store.dispatch('cart/setIsCartUpdating', false);
      } else {
        await this.$store.dispatch('cart/setIsCartUpdating', false);
        this.handlePlaceBetError(response);
      }
    },
    /**
     * Gestisce gli errori durante il piazzamento della scommessa (placeBet)
     *
     * Casi gestiti:
     * - response null/undefined: mostra errore generico
     * - error_code 'update_odds': aggiorna le quote nel carrello
     *   - Se ci sono quote disabilitate/scadute: mostra errore
     *   - Se oddsVariation attivo + quote aggiornate: riprova automaticamente
     *   - Altrimenti: mostra messaggio che le quote sono state aggiornate
     * - error_code 'review': bet in attesa di accettazione manuale
     * - Altri errori: mostra errore nella modale
     */
    async handlePlaceBetError(response: any) {
      console.log('[handlePlaceBetError] Response ricevuta:', response);

      if (!response) {
        console.error('[handlePlaceBetError] Response è null/undefined');
        await this.$store.dispatch('IllinoisSport/setBetOutcomeError', {
          response: {
            result: false,
            error_code: 'generic_error',
            reason: 'Generic Error'
          },
          betType: 'place'
        });
        return;
      }

      // Caso: review - bet in attesa di accettazione manuale
      if (response.error_code === 'review') {
        console.log('[handlePlaceBetError] Gestione review');
        // Codice commentato:
        // await this.$store.dispatch('IllinoisSport/setBetOutcomeReview', {
        //   review_code: response.result || ''
        // });
        // // Aggiunge la bet alla lista di quelle in accettazione
        // await this.$store.dispatch('cart/addBetInAcceptance', {
        //   code: response.result
        // });

        // Nuovo codice: emetti evento per aprire carrello e tab pending
        this.$emit('open-cart-pending');
        return;
      }

      if (response.error_code === 'update_odds') {
        console.log('[handlePlaceBetError] Gestione update_odds');

        if (
          !Array.isArray(response.data_to_update) ||
          response.data_to_update.length === 0
        ) {
          console.error('[handlePlaceBetError] data_to_update non valido');
          // Non mostrare modale in caso di update_odds
          return;
        }

        let currentOdds = [...(this.getBet.odds || [])];
        let hasDisabled = false;
        let hasTimeOver = false;
        let updatedCount = 0;

        // Aggiorna direttamente le quote nel carrello
        for (const updateItem of response.data_to_update as OddsToUpdate[]) {
          const cartOdd = currentOdds.find(
            (o: any) => o.unique_id === updateItem.source
          );

          if (!cartOdd) {
            console.warn(
              '[handlePlaceBetError] Quota non trovata:',
              updateItem.source
            );
            continue;
          }

          switch (updateItem.reason) {
            case 'changed_odd_value':
            case 'changed_multiplicity':
              if (updateItem.newOdd) {
                console.log('[handlePlaceBetError] Prima di updateSingleOdd:', {
                  source: updateItem.source,
                  reason: updateItem.reason,
                  newOdd: updateItem.newOdd,
                  hasChanged: 'changed' in updateItem.newOdd,
                  changedValue: updateItem.newOdd.changed,
                  newOddKeys: Object.keys(updateItem.newOdd),
                  newOddStringified: JSON.stringify(updateItem.newOdd)
                });
                await this.$store.dispatch('cart/updateSingleOdd', {
                  uniqueId: updateItem.source,
                  newOdd: updateItem.newOdd
                });
                // Aggiorna anche currentOdds per mantenere sincronizzazione
                const index = currentOdds.findIndex(
                  (o: any) => o.unique_id === updateItem.source
                );
                if (index >= 0) {
                  currentOdds[index] = { ...updateItem.newOdd };
                }
                updatedCount++;
              }
              break;
            case 'disabled':
              cartOdd.to_remove = true;
              hasDisabled = true;
              console.log(
                '[handlePlaceBetError] Quota disabilitata:',
                updateItem.source
              );
              break;
            case 'time_over':
              cartOdd.to_remove = true;
              hasTimeOver = true;
              console.log(
                '[handlePlaceBetError] Quota scaduta:',
                updateItem.source
              );
              break;
          }
        }

        // Forza aggiornamento Vuex (solo se ci sono modifiche per disabled/time_over)
        // Le modifiche per changed_odd_value/changed_multiplicity sono già state committate da updateSingleOdd
        if (hasDisabled || hasTimeOver) {
          this.$store.commit('cart/SET_ODDS', [...currentOdds]);
        }
        this.$store.commit('IllinoisSport/setShowOddsUpdateMessage', true);
        setTimeout(() => {
          this.$store.commit('IllinoisSport/setShowOddsUpdateMessage', false);
        }, 3000);

        // NON chiamare acceptAllOdds qui perché rimuoverebbe il campo changed
        // che è necessario per hasChangedOdds e per la conferma dell'utente
        // acceptAllOdds verrà chiamato solo quando l'utente conferma le modifiche in confirmChanges()
        // await this.$store.dispatch('cart/acceptAllOdds');
        // Forza aggiornamento UI del riepilogo quote
        await (this as any).$root.$emit('forceUpdateOddsSummary');
        // Ricalcola totali del carrello
        await this.$store.dispatch('cart/refreshCart');

        console.log('[handlePlaceBetError] Quote aggiornate:', updatedCount);

        // Aggiungi errore al carrello se almeno una quota è stata aggiornata
        if (updatedCount > 0) {
          this.$store.commit('cart/ADD_CART_ERROR', {
            message: 'cashout.frozenExpired'
          });
        }

        // Salva oddsToUpdate nello store senza aprire la modale
        await this.$store.dispatch('IllinoisSport/setOddsToUpdate', {
          oddsToUpdate: response.data_to_update as OddsToUpdate[]
        });

        // Gestione retry o errore
        if (hasDisabled || hasTimeOver) {
          // Se ci sono quote disabilitate o scadute, non mostrare modale
          // Le quote sono già state aggiornate e oddsToUpdate è stato salvato
        } else if (this.getOddsVariation && updatedCount > 0) {
          // Se oddsVariation è attivo e ci sono quote aggiornate, riprova automaticamente
          this.warningOddsChanged = true;
          console.log('[handlePlaceBetError] Riprovo saveBet');
          await this.saveBet();
        } else {
          // Le quote sono state aggiornate, oddsToUpdate è stato salvato
          // Non mostrare modale
        }
        return;
      }

      console.log(
        '[handlePlaceBetError] Errore diverso da update_odds:',
        response.error_code
      );
      await this.$store.dispatch('IllinoisSport/setBetOutcomeError', {
        response: response,
        betType: 'place'
      });
    },
    /**
     * Prenota la scommessa (Book Bet)
     * Disponibile solo per eventi prematch
     *
     * Flusso:
     * 1. Verifica autenticazione utente
     * 2. Verifica che il contesto sia 'prematch'
     * 3. Verifica che non ci siano errori nel carrello
     * 4. Invia la richiesta API tramite cart/bookBet
     * 5. In caso di successo: mostra dialog con codice prenotazione
     * 6. In caso di errore: gestisce con handleBookBetError
     */
    async bookingBet() {
      console.log(
        'getAuthenticated',
        this.$store.getters['user/getAuthenticated']
      );
      if (this.$store.getters['user/getAuthenticated'] === false) {
        console.log('openLogin');
        window.parent.postMessage(
          {
            type: 'openLogin'
          },
          '*'
        );
        await this.$store.dispatch('IllinoisSport/setBetOutcomeError', {
          response: { message: 'User Not authorized!!!' },
          betType: 'book'
        });
        return;
      }

      if (this.getBet.context !== 'prematch' || this.getIsCartUpdating === true)
        return;

      await this.$store.dispatch('cart/setIsCartUpdating', true);

      if (
        (!this.getBet.check &&
          this.getBet.errors &&
          this.getBet.errors.length > 0) ||
        this.hasChangedOdds
      ) {
        await this.$store.dispatch('cart/setIsCartUpdating', false);
        return;
      }

      const response: any = await this.$store.dispatch('cart/bookBet', {
        betContext: this.getBet.context,
        lang: this.getLanguage
      });

      if (response && response.result === true) {
        await this.$store.dispatch('IllinoisSport/setBetOutcomeBooked', {
          booked_code: response.shortCode || response.bet_code || ''
        });
        await this.$store.dispatch('cart/setIsCartUpdating', false);
      } else {
        await this.$store.dispatch('cart/setIsCartUpdating', false);
        this.handleBookBetError(response);
      }
    },
    /**
     * Gestisce gli errori durante la prenotazione della scommessa (bookBet)
     * Logica semplificata e allineata a handlePlaceBetError
     */
    async handleBookBetError(response: any) {
      console.log('[handleBookBetError] Response ricevuta:', response);

      // Caso: response null o undefined
      if (!response) {
        console.error('[handleBookBetError] Response è null/undefined');
        await this.$store.dispatch('IllinoisSport/setBetOutcomeError', {
          response: {
            result: false,
            error_code: 'unknown_error',
            reason: 'Errore sconosciuto'
          },
          betType: 'book'
        });
        return;
      }

      // Caso: review - bet in attesa di accettazione manuale
      if (response.error_code === 'review') {
        console.log('[handleBookBetError] Gestione review');
        await this.$store.dispatch('IllinoisSport/setBetOutcomeReview', {
          review_code: response.result || ''
        });
        await this.$store.dispatch('cart/addBetInAcceptance', {
          code: response.result
        });
        return;
      }

      // Caso: update_odds - le quote sono cambiate e devono essere aggiornate
      if (response.error_code === 'update_odds') {
        console.log('[handleBookBetError] Gestione update_odds');

        // Validazione struttura dati
        if (
          !Array.isArray(response.data_to_update) ||
          response.data_to_update.length === 0
        ) {
          console.error('[handleBookBetError] data_to_update non valido');
          // Non mostrare modale in caso di update_odds
          return;
        }

        let currentOdds = [...(this.getBet.odds || [])];
        let hasDisabled = false;
        let hasTimeOver = false;
        let updatedCount = 0;

        // Aggiorna direttamente le quote nel carrello
        for (const updateItem of response.data_to_update) {
          const cartOdd = currentOdds.find(
            (o: any) => o.unique_id === updateItem.source
          );

          if (!cartOdd) {
            console.warn(
              '[handleBookBetError] Quota non trovata:',
              updateItem.source
            );
            continue;
          }

          switch (updateItem.reason) {
            case 'changed_odd_value':
            case 'changed_multiplicity':
              if (updateItem.newOdd) {
                console.log('[handleBookBetError] Prima di updateSingleOdd:', {
                  source: updateItem.source,
                  reason: updateItem.reason,
                  newOdd: updateItem.newOdd,
                  hasChanged: 'changed' in updateItem.newOdd,
                  changedValue: updateItem.newOdd.changed,
                  newOddKeys: Object.keys(updateItem.newOdd),
                  newOddStringified: JSON.stringify(updateItem.newOdd)
                });
                await this.$store.dispatch('cart/updateSingleOdd', {
                  uniqueId: updateItem.source,
                  newOdd: updateItem.newOdd
                });
                // Aggiorna anche currentOdds per mantenere sincronizzazione
                const index = currentOdds.findIndex(
                  (o: any) => o.unique_id === updateItem.source
                );
                if (index >= 0) {
                  currentOdds[index] = { ...updateItem.newOdd };
                }
                updatedCount++;
              }
              break;
            case 'disabled':
              cartOdd.to_remove = true;
              hasDisabled = true;
              console.log(
                '[handleBookBetError] Quota disabilitata:',
                updateItem.source
              );
              break;
            case 'time_over':
              cartOdd.to_remove = true;
              hasTimeOver = true;
              console.log(
                '[handleBookBetError] Quota scaduta:',
                updateItem.source
              );
              break;
          }
        }

        // Forza aggiornamento Vuex (solo se ci sono modifiche per disabled/time_over)
        // Le modifiche per changed_odd_value/changed_multiplicity sono già state committate da updateSingleOdd
        if (hasDisabled || hasTimeOver) {
          this.$store.commit('cart/SET_ODDS', [...currentOdds]);
        }
        this.$store.commit('IllinoisSport/setShowOddsUpdateMessage', true);
        setTimeout(() => {
          this.$store.commit('IllinoisSport/setShowOddsUpdateMessage', false);
        }, 3000);

        // NON chiamare acceptAllOdds qui perché rimuoverebbe il campo changed
        // che è necessario per hasChangedOdds e per la conferma dell'utente
        // acceptAllOdds verrà chiamato solo quando l'utente conferma le modifiche in confirmChanges()
        // await this.$store.dispatch('cart/acceptAllOdds');
        // Forza aggiornamento UI del riepilogo quote
        await (this as any).$root.$emit('forceUpdateOddsSummary');
        // Ricalcola totali del carrello
        await this.$store.dispatch('cart/refreshCart');

        console.log('[handleBookBetError] Quote aggiornate:', updatedCount);

        // Aggiungi errore al carrello se almeno una quota è stata aggiornata
        if (updatedCount > 0) {
          this.$store.commit('cart/ADD_CART_ERROR', {
            message: 'cashout.frozenExpired'
          });
        }

        // Salva oddsToUpdate nello store senza aprire la modale
        await this.$store.dispatch('IllinoisSport/setOddsToUpdate', {
          oddsToUpdate: response.data_to_update as OddsToUpdate[]
        });

        // Gestione retry o errore
        if (hasDisabled || hasTimeOver) {
          // Se ci sono quote disabilitate o scadute, non mostrare modale
          // Le quote sono già state aggiornate e oddsToUpdate è stato salvato
        } else if (this.getOddsVariation && updatedCount > 0) {
          // Se oddsVariation è attivo e ci sono quote aggiornate, riprova automaticamente
          this.warningOddsChanged = true;
          console.log('[handleBookBetError] Riprovo bookingBet');
          await this.bookingBet();
        } else {
          // Le quote sono state aggiornate, oddsToUpdate è stato salvato
          // Non mostrare modale
        }
        return;
      }

      // Caso: altri errori generici
      console.log(
        '[handleBookBetError] Errore diverso da update_odds:',
        response.error_code
      );
      await this.$store.dispatch('IllinoisSport/setBetOutcomeError', {
        response: response,
        betType: 'book'
      });
    },
    /**
     * Pulisce il carrello e resetta tutti gli stati locali
     * Usato dopo aver piazzato/prenotato con successo una scommessa
     */
    async clearCart() {
      this.showAlertLogin = false;
      this.showAlertNotPlayable = false;
      this.warningOddsChanged = false;
      await this.$store.dispatch('IllinoisSport/clearBetOutcome');
      await this.$store.dispatch('cart/resetCart');
    },
    /**
     * Mostra gli alert appropriati se l'utente non è autenticato o non può giocare
     */
    alertLogin() {
      if (!this.getAuthenticated) this.showAlertLogin = true;
      if (!this.getCanPlay) this.showAlertNotPlayable = true;
    },
    async confirmChanges() {
      // Rimuovi le quote disabilitate dal carrello
      const disabledOdds = this.oddsToUpdate.filter(
        (item: any) => item.reason === 'disabled'
      );
      for (const disabledOdd of disabledOdds) {
        await this.$store.dispatch('cart/removeOddFromCart', {
          unique_id: disabledOdd.source
        });
      }
      // Rimuovi l'errore cashout.frozenExpired quando viene confermata la variazione
      this.$store.commit('cart/REMOVE_CART_ERROR', {
        message: 'cashout.frozenExpired'
      });
      // Accetta tutte le quote aggiornate (resetta flag changed) dopo la conferma dell'utente
      await this.$store.dispatch('cart/acceptAllOdds');
      // Svuota oddsToUpdate
      await this.$store.dispatch('IllinoisSport/clearOddsToUpdate');
    }
  }
});
